import {DRAW_RESULT6} from "./types";

const init = {
    isLoading: false,
    data: {},
};

const draw6 = (state = init, {type, payload}) => {
    if (type === DRAW_RESULT6) {
        return {
            ...state,
            isLoading: false,
            data: payload
        };
    } else {
        return state;
    }
};

export default draw6;
